export const useDates = () => {
  const date: Date = new Date();

  const day = date.getDay();

  const today = new Date(date);

  const tomorrow = new Date(date);
  tomorrow.setDate(date.getDate() + 1);

  const saturday = new Date(date);
  const sunday = new Date(date);

  const daysUntilSaturday = (6 - day + 7) % 7;
  const daysUntilSunday = (7 - day + 7) % 7;

  saturday.setDate(date.getDate() + daysUntilSaturday);
  sunday.setDate(date.getDate() + daysUntilSunday);

  return { today, tomorrow, saturday, sunday };
};
